import { GoogleFontIcon } from '@asset-metrix/portal-ui';

import {
  FilterPersistenceIcon,
  type FilterPersistenceMode,
} from './FilterPersistenceIcon';

import styles from './filters.module.scss';

type FilterActionsProps = {
  showResetIcon: boolean;
  resetTitle: string;
  onResetClick?: () => void;
  persistenceMode?: FilterPersistenceMode;
  onPersistenceClick?: () => void;
};

export function FilterActions({
  showResetIcon,
  resetTitle,
  onResetClick,
  persistenceMode,
  onPersistenceClick,
}: FilterActionsProps) {
  return (
    <>
      {persistenceMode != null && (
        <FilterPersistenceIcon
          mode={persistenceMode}
          onClick={onPersistenceClick}
        />
      )}
      {showResetIcon && (
        <GoogleFontIcon
          title={resetTitle}
          onClick={onResetClick}
          solid={true}
          className={styles['resetIcon']}
          name="filter_alt_off"
        />
      )}
    </>
  );
}
